import React from 'react';
import { Link } from 'react-router-dom';
import { RadioTower, Mail, Network, ExternalLink } from 'lucide-react';

const Footer = () => {
  const networkSites = [
    { name: 'RadonLab HQ', url: 'https://radonlab.ca' },
    { name: 'Radon Inspectors', url: 'https://radoninspectors.ca' },
    { name: 'Radon Detectors', url: 'https://radondetectors.ca' },
    { name: 'Radon Kits', url: 'https://radonkits.ca' },
    { name: 'Radon Ventilation', url: 'https://radonventilation.ca' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="col-span-1">
            <Link to="/" className="flex items-center">
              <RadioTower className="h-8 w-8 text-red-600" />
              <span className="ml-2 text-xl font-bold">RadonMap</span>
            </Link>
            <p className="mt-4 text-gray-400">
              Part of the RadonLab Network - Canada's Radon Science Authority
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white">About Radon</Link></li>
              <li><Link to="/testing" className="text-gray-400 hover:text-white">Testing</Link></li>
              <li><Link to="/mitigation" className="text-gray-400 hover:text-white">Mitigation</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white">Blog</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">RadonLab Network</h3>
            <ul className="space-y-2">
              {networkSites.slice(0, 4).map((site, index) => (
                <li key={index}>
                  <a 
                    href={site.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white flex items-center"
                  >
                    {site.name}
                    <ExternalLink className="h-3 w-3 ml-1" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><a href="https://whatisradon.ca" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">Learn About Radon</a></li>
              <li><a href="https://radonrisk.ca" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">Risk Calculator</a></li>
              <li><a href="https://radonlevels.ca" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">Canada Data</a></li>
              <li><a href="https://www.canada.ca/en/health-canada/services/environmental-workplace-health/radiation/radon.html" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">Health Canada</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-red-600" />
                <a href="mailto:info@radonlab.ca" className="text-gray-400 hover:text-white">
                  info@radonlab.ca
                </a>
              </li>
              <li className="mt-4">
                <Link to="/testing" className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 inline-block">
                  Book Testing
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <div className="space-y-4">
            <p>&copy; {new Date().getFullYear()} RadonMap Canada. Part of RadonLab Network. All rights reserved.</p>
            <div className="flex justify-center">
              <a href="https://www.aint.ca" className="group">
                <div className="flex items-center space-x-2">
                  <div className="flex items-center justify-center">
                    <Network className="w-8 h-8 text-red-600 filter drop-shadow-[0_0_8px_rgba(239,68,68,0.5)]" />
                  </div>
                  <div>
                    <span className="text-white">Powered by <span className="text-red-600">AInt</span></span>
                    <span className="block text-sm italic text-gray-400">Innovation You Can Build On</span>
                  </div>
                </div>
              </a>
            </div>
            <p className="text-sm">
              <Link to="/terms" className="hover:text-white">Terms of Service</Link>
              {' • '}
              <a href="/sitemap.xml" className="hover:text-white">Sitemap</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;